import { useState } from "react";
import { Download, Image as ImgIcon } from "lucide-react";

/**
 * Internal asset gallery — not linked from main navigation.
 * Accessible via /brand/galleri
 */

const BRAND_ASSETS = [
  // Mood images
  { name: "Bryllupstale-stemning", file: "/brand/moods/01-bryllup.png", category: "Stemning", size: "1080×1080" },
  { name: "Konfirmation", file: "/brand/moods/02-konfirmation.png", category: "Stemning", size: "1080×1080" },
  { name: "Rund fødselsdag", file: "/brand/moods/03-rund-foedselsdag.png", category: "Stemning", size: "1080×1080" },
  { name: "Studentertale", file: "/brand/moods/04-studentertale.png", category: "Stemning", size: "1080×1080" },
  { name: "Tale i hånden", file: "/brand/moods/05-tale-i-haanden.png", category: "Stemning", size: "1080×1080" },
  { name: "Skål / Toast", file: "/brand/moods/06-skaal.png", category: "Stemning", size: "1080×1080" },
  // Logo
  { name: "Logo 170×170 (Facebook profil)", file: "/brand/logo-170.png", category: "Logo", size: "170×170" },
  { name: "Logo 512×512", file: "/brand/logo-512.png", category: "Logo", size: "512×512" },
  { name: "Logo 1024×1024 (print)", file: "/brand/logo-1024.png", category: "Logo", size: "1024×1024" },
  { name: "Logo 192×192 (Android)", file: "/brand/logo-192.png", category: "Logo", size: "192×192" },
  { name: "Favicon 32×32", file: "/brand/favicon-32.png", category: "Logo", size: "32×32" },
];

export default function BrandGalleryPage() {
  const [filter, setFilter] = useState("Alle");
  const categories = ["Alle", "Stemning", "Logo"];
  const items =
    filter === "Alle" ? BRAND_ASSETS : BRAND_ASSETS.filter((a) => a.category === filter);

  return (
    <div className="min-h-screen bg-background py-8 md:py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <ImgIcon className="h-10 w-10 text-secondary mx-auto mb-3" />
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-primary">
            Brand galleri
          </h1>
          <p className="text-muted-foreground mt-3 max-w-xl mx-auto">
            Download stemningsbilleder og logoer til brug på Facebook, Instagram og andre kanaler.
          </p>
        </div>

        {/* Filter */}
        <div className="flex justify-center gap-2 mb-8 flex-wrap">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                filter === c
                  ? "bg-primary text-primary-foreground shadow"
                  : "bg-white border border-border text-primary hover:border-secondary"
              }`}
              data-testid={`gallery-filter-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((asset) => (
            <div
              key={asset.file}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-border/40"
              data-testid={`gallery-item-${asset.name.replace(/\s/g, "-").toLowerCase()}`}
            >
              <div className="aspect-square bg-muted/30 relative overflow-hidden flex items-center justify-center p-4">
                <img
                  src={asset.file}
                  alt={asset.name}
                  loading="lazy"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <div className="p-4">
                <p className="text-xs uppercase tracking-wider text-secondary font-medium mb-1">
                  {asset.category} · {asset.size}
                </p>
                <h3 className="font-heading text-base text-primary font-bold mb-3">
                  {asset.name}
                </h3>
                <a
                  href={asset.file}
                  download
                  className="inline-flex items-center gap-2 text-sm bg-primary hover:bg-primary/90 text-primary-foreground px-4 py-2 rounded-full transition-colors"
                >
                  <Download className="h-4 w-4" />
                  Download
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-muted-foreground mt-12">
          Tip: Højreklik på et billede og vælg &ldquo;Gem som&rdquo; hvis Download-knappen ikke virker i din browser.
        </p>
      </div>
    </div>
  );
}
